module.exports = __webpack_public_path__ + "img/SIDEBAR_Abschluss.94294c77.svg";